<script>
    import { notificate } from "../../../services/notification.js";
    import integrationService from "../service.js";
    import BreadCrumNav from "../../../components/breadcrum-nav.svelte";
    import API from "../../../services/v2-api";
    import { onMount, tick } from "svelte";
    import { format } from "svelte-i18n";

    let tooltip = $state();
    let postAddModal;
    let dockerModal;
    let dockerComposeModal;
    let responseCopied = false;
    let postAddResponse;
    let config_selected = $state("");
    let config_file = $state();

    async function handleSubmit(platform) {
        if (responseCopied) responseCopied = false;
        config_selected = platform;

        let response = await integrationService
            .searchAgent({ filter: { platform: platform } })
            .catch((errors) => {
                return false;
            });
        config_file = response;
        postAddModal.modal("show");
        return true;
    }

    const closeResponseModal = async () => {
        postAddModal.modal("hide");
    };

    const handleCopy = async (str, tooltip) => {
        copyText(str, tooltip);
    };

    const copyText = async (str, tooltip) => {
        await tick();
        if ("clipboard" in navigator) {
            navigator.clipboard
                .writeText(str)
                .then(() => {
                    showTooltip(tooltip);
                    hideTooltip(tooltip);
                })
                .catch((err) => console.error(err.name, err.message));
        } else {
            let selBox = document.createElement("textarea");
            selBox.style.position = "fixed";
            selBox.style.left = "0";
            selBox.style.top = "0";
            selBox.style.opacity = "0";
            selBox.value = str;
            document.body.appendChild(selBox);
            selBox.focus();
            selBox.select();
            // @TODO: upgrade to clipboard API
            try {
                const success = document.execCommand("copy");
            } catch (err) {
                return false;
            }
            showTooltip(tooltip);
            document.body.removeChild(selBox);
            hideTooltip(tooltip);
            responseCopied = true;
        }
        responseCopied = true;
    };

    const hideTooltip = (tooltip) => {
        setTimeout(() => {
            tooltip.classList.add("trigger-opacity-cero");
            tooltip.classList.remove("trigger-opacity-one");
            setTimeout(() => tooltip.classList.add("d-none"), 1000);
        }, 2000);
    };

    const showTooltip = (tooltip) => {
        tooltip.classList.remove("d-none");
        setTimeout(() => {
            tooltip.classList.remove("trigger-opacity-cero");
            tooltip.classList.add("trigger-opacity-one");
        }, 1000);
    };

    const downloadFile = async (platform = "linux") => {
        const fileExt =
            platform == "linux"
                ? "sh"
                : platform == "linux_ansible"
                  ? "yaml"
                  : "ps1";
        const fileBlob = new Blob([config_file], { type: "text/plain" });
        const fileUrl = URL.createObjectURL(fileBlob);
        const anchor = document.createElement("a");
        anchor.href = fileUrl;
        anchor.download = `vulseek-agent-${platform}.${fileExt}`;
        document.body.appendChild(anchor);
        anchor.click();
        document.body.removeChild(anchor);

        URL.revokeObjectURL(fileUrl);
        responseCopied = true;
    };

    onMount(() => {
        postAddModal = jQuery("#postAdd-modal").modal({ show: false });
        dockerModal = jQuery("#docker-modal").modal({ show: false });
        dockerComposeModal = jQuery("#dockercompose").modal({ show: false });
    });
</script>

<section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-6">
                <h1 class="mt-3 mb-3 page-title">
                    <i class="fas fa-user-shield fa-xs"></i>
                    Vulseek Agent
                </h1>
            </div>
            <div class="col-6">
                <BreadCrumNav
                    routes={[
                        {
                            path: "/integration/",
                            label: $format("layout.sidebar.integrations"),
                        },
                        { label: "Vulseek Agent" },
                    ]}
                />
            </div>
        </div>
    </div>
</section>

<section class="content mt-5">
    <div class="container-fluid">
        <div class="row mt-3">
            <div class="col-12 d-flex" style="gap: 15px;">
                <div
                    class="small-box bg-white"
                    style="flex: 1; cursor: pointer;"
                    onclick={() => handleSubmit("linux_ansible")}
                >
                    <div class="inner">
                        <h3>Linux - Ansible</h3>
                        <p>{$format("page.integration.scanner.compose")}</p>
                        <div class="icon">
                            <i><img src="/img/logo-ansible.png" alt="" /></i>
                        </div>
                    </div>
                </div>
                <div
                    class="small-box bg-white"
                    style="flex: 1; cursor: pointer;"
                    id="getfileBtn"
                    onclick={() => handleSubmit("linux")}
                >
                    <div class="inner">
                        <h3>Linux</h3>
                        <p>{$format("page.integration.scanner.compose")}</p>
                        <div class="icon">
                            <i class="docker-img-container"
                                ><img src="/img/logo-linux.png" alt="" /></i
                            >
                        </div>
                    </div>
                </div>
                <div
                    class="small-box bg-white"
                    style="flex: 1; cursor: pointer;"
                    onclick={() => handleSubmit("windows")}
                >
                    <div class="inner">
                        <h3>Windows</h3>
                        <p>{$format("page.integration.scanner.compose")}</p>
                        <div class="icon">
                            <i><img src="/img/logo-windows.png" alt="" /></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- POSTADD MODAL -->
<div
    class="modal fade show"
    id="postAdd-modal"
    data-keyboard="false"
    data-backdrop="static"
    style="display: none; padding-right: 9px;"
    aria-modal="true"
    role="dialog"
>
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {$format("page.integration.scanner.modal.title")}
                </h4>
                <button
                    type="button"
                    class="btn-close"
                    onclick={closeResponseModal}
                    aria-label="Close"
                >
                </button>
            </div>
            <div class="modal-body">
                <button
                    class="btn btn-copy far fa-copy"
                    title="Copiar al portapapeles"
                    aria-label="Copiar"
                    onclick={() => handleCopy(config_file, tooltip)}
                ></button>
                <span
                    id="tooltip"
                    class="d-none trigger-opacity-cero copy-tooltip"
                    bind:this={tooltip}>{$format("copied")}</span
                >
                <div class="console mb-3">
                    {config_file}
                </div>
                <div class="mt-3 mb-3">
                    <button
                        class="btn btn-default"
                        onclick={() => downloadFile(config_selected)}
                        >{$format("buttons.download_file")}</button
                    >
                </div>
            </div>
        </div>
        <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
</div>

<!-- END POSTADD MODAL-->

<style>
    .icon {
        text-align: center;
    }
    .icon i {
        width: 100px;
        top: -20px !important;
    }
    .icon i img {
        max-width: 100%;
        width: 200px;
        height: 200px;
    }

    .console {
        background: hsl(0, 0%, 96.5%);
        color: black-750;
        font-family: "Lucida Console", "Courier New", monospace;
        white-space: break-spaces;
        padding: 15px;
    }
    .btn-copy {
        float: right;
        position: relative;
        top: 5px;
        right: 5px;
    }
    .icon i.docker-img-container {
        width: 95px !important;
    }
    #tooltip {
        position: absolute;
        right: -60px;
        top: 50px;
    }
</style>
